<button [ngClass]="buttonClasses()">
  <ion-icon [name]="state().icon"></ion-icon>
</button>
